export default function FMEXRoadmap() {
  return (
    <section id="roadmap" className="relative w-full h-[100vh] py-20 bg-transparent overflow-hidden flex items-center justify-center" >
 
  {/* Title */}
  <h2
    className="absolute uppercase font-darumadrop top-5 text-4xl sm:text-4xl md:text-5xl mb-4 text-center text-white drop-shadow-[3px_3px_0px_#030303]"
  >
    Roadmap - Acts Of Revenge
  </h2>

  <div className="relative w-full max-w-5xl h-full flex items-center justify-center">
    {/* Phase 1 */}
    <div className="absolute top-[10%] right-[50%] md:top-[10%] md:right-[40%] bg-white border-4 border-black rounded-2xl p-2 sm:p-4 w-[180px] sm:w-[260px] md:w-[300px] rotate-[-3deg] mx-auto md:mx-0">
      <h3
        className="font-bold text-base sm:text-xl text-pink-700 mb-1 leading-[1.1]"
        style={{ fontFamily: 'Darumadrop One, cursive' }}
      >
        Phase 1 <br /> Heartbreak to Blockchain
      </h3>
      <ul className="list-disc list-inside text-[11px] sm:text-xs text-black font-semibold pl-3 space-y-1">
        <li>Got dumped.</li>
        <li>Idea mid-breakdown.</li>
        <li>Deployed smart contract instead of another text.</li>
        <li>Certified heartbreak survivors unite.</li>
      </ul>
    </div>

    {/* Phase 2 */}
    <div className="absolute top-[10%] right-[3%] md:right-[5%] bg-white border-4 border-black rounded-2xl p-3 sm:p-4 w-[180px] sm:w-[250px] md:w-[280px] h-auto md:h-[200px] rotate-[4deg] mx-auto md:mx-0">
      <h3
        className="font-bold font-darumadrop text-base sm:text-xl text-purple-700 mb-1 leading-[1.1]">
        Phase 2 <br /> Token Launch
      </h3>
      <ul className="list-disc list-inside text-[11px] sm:text-xs text-black font-semibold pl-3 space-y-1">
        <li>FMEX presale goes live.</li>
        <li>Petty Challenges activated.</li>
        <li>Token claim & emotional stability.</li>
        <li>DEX Listing.</li>
      </ul>
    </div>

    {/* Phase 3 */}
    <div className="absolute top-[55%] right-[49%] md:right-[35%] bg-white border-4 border-black rounded-2xl p-3 sm:p-4 w-[180px] sm:w-[250px] md:w-72 rotate-[-5deg] mx-auto md:mx-0">
      <h3
        className="font-bold font-darumadrop text-base sm:text-xl text-blue-700 mb-1 leading-[1.1]" >
        Phase 3 <br /> Growth & Utility
      </h3>
      <ul className="list-disc list-inside text-[11px] sm:text-xs text-black font-semibold space-y-1">
        <li>Staking launch: Earn while healing.</li>
        <li>Web3 Therapy Session.</li>
        <li>FMEX App rollout.</li>
        <li>Celebrity collab.</li>
        
      </ul>
    </div>

    {/* Phase 4 */}
    <div className="absolute top-[55%] right-[0%] bg-white border-4 border-black rounded-2xl p-3 sm:p-4 w-[180px] sm:w-[250px] md:w-72 rotate-[3deg] mx-auto md:mx-0">
      <h3
        className="font-extrabold font-darumadrop text-base sm:text-xl text-yellow-700 mb-1 leading-[1.1]">
        Phase 4 <br /> World Domination
      </h3>
      <ul className="list-disc list-inside text-[11px] sm:text-xs text-black font-semibold space-y-1">
        <li>Major CEX listings.</li>
        <li>Events & giveaways.</li>
        
        <li>Ex-Therapy DAO.</li>
        <li>Massive burn events.</li>
        <li>Mental health donations.</li>
      </ul>
    </div>
  </div>
</section>

  );
}
